/**
 * Escape a value for embedding inside a single-quoted formula string literal.
 * Without this, quote/backslash characters in user-provided symbols would break
 * the formula expression passed to `FilterStage`.
 */
export function escapeFormulaStringLiteral(value: string): string {
    return value.replace(/\\/g, '\\\\').replace(/'/g, "\\'");
}
